import React from 'react';

type DoneToggleButtonProps = {
  onMarkDone?: () => void;
  onUndone?: () => void;
};

export function DoneToggleButton({ onMarkDone, onUndone }: DoneToggleButtonProps) {
  const onToggle = onUndone ?? onMarkDone;
  if (!onToggle) return null;

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`rounded border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium hover:bg-slate-50 ${onUndone ? 'text-slate-500' : 'text-slate-700'}`}>
      {onUndone ? 'Mark not done' : 'Done'}
    </button>
  );
}
